(function ($) {
    //Eliminar código HTML de una cadena
    function stripHtml(html)
    {
        let tmp = document.createElement("DIV");
        tmp.innerHTML = html;
        return tmp.textContent || tmp.innerText || "";
    }

    //Función para formatear pasar un nombre completo a sus dos primeras palabras, con guiones por espacios, sin mayúsculas ni caracteres raros
    //Actualizado a tomar las palabras segunda y tercera (por la inclusión de Dr/Dra) y limpiar espacios extraños (trim())
    function nameSur(nameSurname){
        var noDots = nameSurname.split('.').join("").trim();
        var twoFirstWords = noDots.split(' ').slice(1,3).join(' ');
        var noSpacesNoUppercase = twoFirstWords.replace(/\s+/g, '-').toLowerCase();
        var noWeirdCharacters = noSpacesNoUppercase.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return noWeirdCharacters;
    }
    /*
    function nameSur(nameSurname){
        var noDots = nameSurname.split('.').join("");
        var twoFirstWords = noDots.split(' ').slice(0,2).join(' ');
        var noSpacesNoUppercase = twoFirstWords.replace(/\s+/g, '-').toLowerCase();
        var noWeirdCharacters = noSpacesNoUppercase.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return noWeirdCharacters;
    }
    */

    //Para añadir el nombre del líder al link del researcg group como hash en la página del investigador
    if (window.location.pathname.search("eulalia-de-nadal")>-1 || window.location.pathname.search("francesc-posas")>-1){
        var element = document.querySelector('.research_group_name');
        var pageTitle = document.querySelector('#pageTopContent h1');
        var spanText = stripHtml(pageTitle.getElementsByTagName("span")[0].innerHTML);
        var nameSurname = nameSur(spanText);
        var url = element.getElementsByTagName("a")[0];
        var href = url.getAttribute("href");
        url.setAttribute("href",href+"#"+nameSurname);
    };

})(jQuery, Drupal);